// Берет из utm промокод и вставляет его в input
const getUtmPromocode = () => {
    try {
        const getParam = (param) => {
            const urlParams = new URL(window.location.toString()).searchParams
            return urlParams.get(param) || ''
        }

        const utm = getParam('promocode');
        const input = document.querySelector('input[name=ParticipantNumber]')

        if (utm && input) {
            input.value = utm;
            input.style.display = "none";
        } 
    } catch(e) {
        console.log(e);        
    }
}

export default getUtmPromocode;